exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#driver .el-upload{text-align:center}#driver .el-upload .el-upload-dragger{width:200px !important;height:200px !important}#driver .el-upload .avatar{-o-object-fit:cover;object-fit:cover;border-radius:4px;position:absolute;left:0;width:100%;top:0;height:100%}#driver .dialog-footer{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}", ""]);

// exports
